<div
	class="circle"
	[ngStyle]="{ backgroundColor: backgroundColor, color: textColor }"
>
	<h1 class="circle-text">
		{{ initialLetters }}
	</h1>
</div>
